module.exports = app_ssal_savedSearchUnsubscribed;